import {Stack, Text} from '@mantine/core'
import {notifications} from '@mantine/notifications'

export function showDateMoveWarnings(warnings: readonly string[] | null | undefined): void {
    const lines = (warnings ?? []).filter((warning) => warning.trim().length > 0)
    if (lines.length === 0) {
        return
    }

    notifications.show({
        title: 'Schedule warnings',
        color: 'yellow',
        autoClose: false,
        message: (
            <Stack gap={2} data-testid="date-move-warnings">
                {lines.map((line) => (
                    <Text key={line} size="sm">
                        {line}
                    </Text>
                ))}
            </Stack>
        ),
    })
}
